import _ from 'lodash';


export function initFlags(base, cookie_name='flags') {
	const flags = {...base, ...getOverrides(cookie_name)};
	function flag(id, fallback) {
		return id in flags ? flags[id] : fallback;
	}
	flag.all = () => flags;
	return flag;
}

window.flag = initFlags(window.config.flags, 'flags');
export default window.flag;


// These cookie functions are not feature flag specific, however this is the
// only module that uses them at the moment. Please promote them to a standalone
// module if you wish to use them elsewhere.

export function getOverrides(cookie_name='flags') {
	var overrides = {};
	try {
		overrides = JSON.parse(getCookies()[cookie_name] || '{}');
	} catch(e) {}

	return overrides;
}

export function setOverrides(updates, cookie_name='flags') {
	const overrides = getOverrides(cookie_name);
	_.forEach(updates, (v, k) => {
		if (v === undefined) {
			delete overrides[k];
		} else {
			overrides[k] = v;
		}
	});
	setCookies({[cookie_name]: JSON.stringify(overrides)});
}

function getCookies() {
	const cookies = {};
	document.cookie.split(';').forEach(c => {
		const [key, value] = c.split('=');
		cookies[key.trim()] = value.trim();
	});
	return cookies;
}

function setCookies(changes) {
	_.forEach(changes, (v, k) => {
		setCookie(k, v);
	});
}

function setCookie(key, value, days) {
	if (value === undefined) {
		return setCookie(key, '', -1);
	}

	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = `; expires=${date.toGMTString()}`;
	}
	document.cookie = `${key}=${value}${expires}; path=/`;
}



/** WEBPACK FOOTER **
 ** core/client/rawr/flags.js
 **/